import { OptimizerContext } from '@/optimizer/optimizerContext';
import { useContext } from 'use-context-selector';

export const useOptimizer = () => {
    const context = useContext(OptimizerContext);

    if (!context) {
        throw new Error(
            'useOptimizer must be used within an OptimizerContextProvider',
        );
    }

    return {
        optimizer: context.optimizer,
        optimizerReady: context.optimizerReady,
        medias: context.optimizer.medias,
        setRules: context.setRules,
        rules: context.rules,
        setDashboardType: context.setDashboardType,
        dashboardType: context.dashboardType,
        optimizerInitError: context.optimizerInitError,
        setOptimizerInitError: context.setOptimizerInitError,
        resetOptimisationRules: async () => {
            if (typeof context.optimizer.resetOptimisationRules === 'function') {
                await context.optimizer.resetOptimisationRules();
            }
        },
        getOptimizerVersion: async (): Promise<string> =>
            context.optimizer.getOptimizerVersion(),
        getActiveDaysPerMedium: (): Promise<Record<string, number>> =>
            context.optimizer.getActiveDaysPerMedium(),
    };
};
